import {memo} from 'react';

import styled from 'styled-components';

import EmptyResultImage from '~/assets/images/menu-empty-search.svg?react';
import {getLocalizationService} from '~/shared/services/localisationService';
import {media} from '~/shared/theme/media';
import {body20Bold, subheader24Bold} from '~/shared/theme/typography';

const NoOrdersContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 16px;
  ${media.minLargeMobile`
    margin-top: 32px;
  `}
`;

const TextWrapper = styled.div`
  margin-top: 24px;
`;

const Text = styled.div`
  ${body20Bold}
  line-height: 28px;
  text-align: center;
  color: ${({theme}) => theme.colors.contentDefault};
  ${media.minLargeMobile`
    ${subheader24Bold}
    line-height: 32px;
  `}
`;

const EmptyResultImageStyled = styled(EmptyResultImage)`
  width: 200px;
  height: 200px;
`;

export const NoOrdersThisMonthEmptyState = memo(() => {
  const {t} = getLocalizationService();

  return (
    <NoOrdersContainer data-test-id="noOrdersEmptyState">
      <EmptyResultImageStyled />
      <TextWrapper>
        <Text>{t('no_orders_this_month')}</Text>
      </TextWrapper>
    </NoOrdersContainer>
  );
});
